import { render } from "./HomeFootnotes.vue?vue&type=template&id=cb668da8&scoped=true"
const script = {}

import "./HomeFootnotes.vue?vue&type=style&index=0&id=cb668da8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb668da8"]])

export default __exports__